export { default } from './CercadorEleccions';
